// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box[data-v-76e61adb] {\n    border: 1px solid gray;\n    background: rgb(240,240,240);\n    box-shadow: 5px 5px 10px 1px rgb(200,200,200);\n    border-radius: 2px;\n    margin-bottom: 0.5em;\n    display:flex;\n    justify-content: space-between;\n    padding: 4px 1em;\n}\n", ""]);
// Exports
module.exports = exports;
